export default "/Frontend/dist/csv-white.dc76aedd07babf8510e6ecb3140b0fab.svg";